import { query } from '@confluence/query-preloader-tools';
import { expVal } from '@confluence/feature-experiments';

import { FooterCreateButtonsQuery } from '../src/queries/FooterCreateButtonsQuery.graphql';

export function preloadFooterCreateButton(spaceKey: string) {
	if (expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		return Promise.resolve();
	}

	return query({
		query: FooterCreateButtonsQuery,
		variables: {
			errorPolicy: 'all',
			spaceKey,
		},
	});
}
